// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"79":"release-notes","277":"mfp","536":"new","986":"regions"}[chunkId] + "." + {"79":"c239ccc5","277":"602adee1","536":"74edf4f8","986":"14b90769"}[chunkId] + ".chunk.css";
};